import { UNKNOWN_TIMEZONE } from "@utils/peopleUtils"
import DefaultModal from "@ui/DefaultModal"
import { useTeeupPeopleStore } from "stores/teeupPeopleStore"

import TimezoneRow from "../../Content/Timezone/TimezoneRow"
import { useTimezoneGroups } from "../../Content/Timezone/useTimezoneGroups"
import { formatZoneDate } from "../../Content/Timezone/timezoneDisplay"
import ModalHeader from "../../../ui/DefaultModal/Header"

import "./index.scss"

// Restores the original Time Zone Summary popup (mobile 2018-2019, teeup-mobile
// timezonesSummaryView.js, commits f37d9157cc/ff44fe5cf0): a one-tap modal listing ALL
// participants' timezones/local times. REUSES the spec-compliant zone rows built for the
// People-card group (Content/Timezone/TimezoneRow, same ordering/Unknown-bucket/offset-indicator
// logic via useTimezoneGroups) rather than re-implementing them -- only the chrome (modal +
// header) is new here. Entry points: the People card's "Multitimezone" chip
// (TeeupPeople/TitleContent) and (where additively possible) the When-suggestion surface's
// SuggestionPopup Date-details tab.
const TimeZoneSummary = ({ people }) => {
  const isOpen = useTeeupPeopleStore(state => state.isTimeZoneSummaryModalOpen)
  const setIsOpen = useTeeupPeopleStore(
    state => state.setIsTimeZoneSummaryModalOpen
  )

  const { zoneGroups, unknownGroup, now, viewerTimezone } =
    useTimezoneGroups(people)

  const handleClose = () => setIsOpen(false)

  const zoneCount = zoneGroups.length

  return (
    <DefaultModal open={isOpen} onClose={handleClose}>
      <div className="time-zone-summary-modal">
        <ModalHeader
          onClose={handleClose}
          title="Time Zone Summary"
          isWithIndent
        />

        <div className="time-zone-summary-header">
          <h4>{zoneCount} TIME ZONES</h4>
          <div className="time-zone-summary-header-current">
            <span>Current Time</span>
            <span>{formatZoneDate(now)}</span>
          </div>
        </div>

        <div className="time-zone-summary-rows">
          {zoneGroups.map(group => (
            <TimezoneRow
              key={group.timezone}
              timezone={group.timezone}
              people={group.people}
              offsetHours={group.offsetHours}
              isViewerZone={group.isViewerZone}
              viewerTimezone={viewerTimezone}
              now={now}
            />
          ))}

          {/* Spec: "UNKNOWN bucket at the BOTTOM". */}
          {unknownGroup.length > 0 && (
            <TimezoneRow
              key={UNKNOWN_TIMEZONE}
              timezone={UNKNOWN_TIMEZONE}
              people={unknownGroup}
              now={now}
              isUnknown
            />
          )}
        </div>
      </div>
    </DefaultModal>
  )
}

export default TimeZoneSummary
